import SolidButton from "@/app/components/ui/Buttons/SolidButton";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setShiftDetails } from "@/app_redux/reducers/slices/auth/rota_slice";
import { useNavigate } from "react-router";

const BatchHeaderSection = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handelAddNavigate = () => {
    navigate(`/app/inventory/batch-add`);
    dispatch(setShiftDetails({ data: null }));
  };

  return (
    <div className=" w-full rounded-md bg-white  flex items-center justify-between px-2 my-2 py-2">
      <h3 className="text-base font-semibold">Listed Batch Groups</h3>

      <SolidButton onButtonClick={() => handelAddNavigate()} size="XL">
        + Add Batch Group{" "}
      </SolidButton>
    </div>
  );
};
export default BatchHeaderSection;
